export const checkHasProfit = (value: number) => value >= 0;
